import React from 'react'
import { useNavigate } from 'react-router-dom';
import AddSheet from 'assets/img/AddSheet.svg'
import ContainedButton from 'components/Ui/ContainedButton';

// import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';

const FermeNo1 = ({ disabled }) => {
  const navigate = useNavigate();
  const navigateToCreateStock = () => {
    navigate('/stock-sheet/create-stock');
  }

  if (disabled) {
    return <ContainedButton contentText={"Créer une fiche de stock"}
      disabled={true} />
  }
  return (
    <ContainedButton contentText={"Créer une fiche de stock"} OnClick={navigateToCreateStock} />
  )
}

export default FermeNo1